<mat-form-field class="Autocomplete" [appearance]="appearance" class="w-full">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    type="text"
    #textInput
    class="Autocomplete__input"
    (focus)="onFocus()"
    [placeholder]="placeholder"
    [attr.aria-label]="placeholder"
    matInput
    [formControl]="formControl"
    [matAutocomplete]="auto"
  />
  <mat-progress-bar class="Autocomplete__progressbar" [mode]="'indeterminate'" [hidden]="!IS_LOADING"></mat-progress-bar>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let option of options$ | async" [value]="option">
      <div class="value-container">
        <div class="option-unit" *ngIf="option.unit_id !== (activeUnit$ | async)?.id && option.unit && option.unit_id !== option.id">
          {{ option.unit.title }}
        </div>
        <div class="option-unit" *ngIf="option.parent">{{ option.parent.title }}</div>
        <div class="option-value">{{ option[displayProperty] }}</div>
      </div>
    </mat-option>
    <!-- <mat-option *ngIf="searchOptions?.length == 0 && !IS_LOADING && HAS_FOCUSED" disabled>Inga resultat hittades</mat-option> -->
  </mat-autocomplete>
</mat-form-field>
